import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Flex } from '@chakra-ui/react';
import Head from 'next/head';
import { LogoLoading } from '@aftersale-next/ui';
import { useEcommerceEnabled, useEcommerceName, useIsFetchingEcommerce } from '@aftersale-next/atoms';
export var Page = function Page(_ref) {
  var children = _ref.children,
      testid = _ref.testid,
      _ref$needEnableCheck = _ref.needEnableCheck,
      needEnableCheck = _ref$needEnableCheck === void 0 ? false : _ref$needEnableCheck,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? undefined : _ref$id;

  var _useEcommerceName = useEcommerceName(),
      _useEcommerceName2 = _slicedToArray(_useEcommerceName, 1),
      ecommerceName = _useEcommerceName2[0];

  var _useEcommerceEnabled = useEcommerceEnabled(),
      _useEcommerceEnabled2 = _slicedToArray(_useEcommerceEnabled, 1),
      isEcommerceEnabled = _useEcommerceEnabled2[0];

  var _useIsFetchingEcommer = useIsFetchingEcommerce(),
      _useIsFetchingEcommer2 = _slicedToArray(_useIsFetchingEcommer, 1),
      isFetchingInitialSettings = _useIsFetchingEcommer2[0];

  var title = [ecommerceName, 'rastreio'].filter(Boolean).join(' | ');
  var showLoading = isFetchingInitialSettings || !isEcommerceEnabled;
  return /*#__PURE__*/_jsxs(Flex, {
    w: "100%",
    minH: "100vh",
    direction: "column",
    align: "center",
    justify: "center",
    overflow: "auto",
    bg: "gray.bg",
    "data-testid": testid,
    id: id,
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("title", {
        children: title
      })
    }), showLoading && needEnableCheck ? /*#__PURE__*/_jsx(LogoLoading, {}) : children]
  });
};